<template>
  <v-container fill-height fluid>
    <v-row justify="center">
      <v-col cols="12" md="12">
        <material-card title="Envio de Notificações">
          <v-form ref="formNotificacao">
            <v-container class="py-0">
              <v-row>
                <v-col cols="12" md="6" sm="12">
                  <v-text-field
                    ref="titulo"
                    :rules="requiredRule"
                    autofocus
                    required
                    maxlength="20"
                    label="Título"
                    v-model="notificacao.titulo"
                  />
                </v-col>
                <v-col cols="12" md="12">
                    <v-textarea
                    :rules="requiredRule"
                    required
                    v-model="notificacao.mensagem"
                    name="input-7-4" label="Mensagem"></v-textarea>
                </v-col>               
                <v-col
                  style="margin-top: -20px"
                  cols="12"
                  sm="12"
                  class="text-center"
                >
                  <v-btn @click="submit()" color="success">
                    <v-icon left>mdi-content-save</v-icon>Enviar
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>       
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import rules from "@/utils/rules";

export default {
  mixins: [rules],  
  data() {
    return {
      notificacao: {
        titulo: '',
        mensagem: '',
      },
    };
  },
  mounted() {},
  methods: {
    ...mapActions("notificacao", ["salvar"]),
    limpar() {
      this.notificacao = { titulo: '', mensagem: '' };
      this.$refs.form.reset();
    },    
    enviarDados() {
      this.salvar(this.notificacao).then(() => {        
        this.openAlertSuccess("Notificação enviada com sucesso!");
        this.limpar();
      });
    },
    submit() {
      if (this.$refs.formNotificacao.validate()) {
        this.openConfirmDialog({
            message: `Confirma o envio da notificação? Ao Confirmar esta operação não poderá ser desfeita.`,
            yes: () => {
                this.enviarDados();
            },
        });
      }
    },    
  }  
};
</script>